<template>
    <ul class="list-inline mb-0 p-0 flex flex-col gap-3 mt-4 font-roboto text-[16px] text-[#666666]">
        <li>* Repair claims are limited to $500 per service call and $2,000 per plan in the aggregate per plan term.
            Plans are provided by NRG Protects Inc. Independent contractors will be performing various services under
            the plan. In some instances we may make a cash payment in lieu of repairs or replacement in the amount of
            actual cost, which may be less than retail, to repair or replace any covered system, component, or
            appliance.</li>
        <li>
            **If your authorized repair technician determines that the covered appliance or system is deemed
            irreparable, we will give you a credit of $500 towards a replacement product or system by your authorized
            repair technician.
        </li>
        <li>
            * Repair claims are limited to $500 per service call and $2,000 per plan in the aggregate per plan term.
            Plans are provided by NRG Protects Inc. Independent contractors will be performing various services under
            the plan. In some instances we may make a cash payment in lieu of repairs or replacement in the amount of
            actual cost, which may be less than retail, to repair or replace any covered system, component, or
            appliance.
        </li>
        <li>

            **If your authorized repair technician determines that the covered appliance or system is deemed
            irreparable, we will give you a credit of $500 towards a replacement product or system by your authorized
            repair technician.</li>
        <li>
            ***If your authorized repair technician determines that the water heater is deemed irreparable, we will give
            you a credit of $500 towards a replacement water heater by your authorized repair technician.</li>

        <li>
            ****The customer will be responsible for finding a qualified service provider for claims under this plan.
            Further, the customer will be required to pay the diagnostic fee charged by the qualified service provider,
            for which the customer will be reimbursed up to $100 for covered claims upon receipt of a claim form. The
            surge claim reimbursement for replacement is limited to the replacement value up to $2,000 per plan in the
            aggregate per plan term and includes the diagnostic reimbursement.</li>
        <li>
            †Coverage is provided up to a maximum aggregate limit of $5,000 each term for each covered line (water or
            septic/sewer).</li>
        <li>
            ‡The maximum of $500 each term to fix landscape damaged by the repairs is included in the aggregate limit of
            $5,000. Customer must provide documentation of any landscape repairs.</li>
        <li>
            §Coverage is provided up to a maximum aggregate limit of $5,000 each term for the repair of a section of
            public sidewalk or street that was required to be cut or excavated to conduct the repairs to each covered
            line (water or sewer/septic line).</li>
        <li>
            Once the plan commences, there is a 30-day waiting period before you may request repair services for a
            claim. There is no waiting period for maintenance requests. Unless the plan provider elects not to renew the
            plan, upon expiration of the first year, the plan will automatically renew at the standard rate and terms
            unless you opt out of the auto-renewal option in writing by mail at P.O. Box 2309, Houston, TX 77252- 2309,
            by email at cancel@nrgprotects.com or by calling us at 1.855.241.9094. Sales tax will be added in select
            states.</li>
        <li>
            Personal Electronics Disclaimer: *Our obligation to pay for the repair (including any trip charge, shipping
            costs, parts, and labor), reimbursement, or replacement of covered equipment is limited to up to $2,000 per
            service call and up to $5,000 per plan
        </li>
    </ul>
</template>